(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talli-lunchbox-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('talli-lunchbox-guide')) {
  customElements.define('talli-lunchbox-guide', class extends HTMLElement {
    connectedCallback() {
      this.onSelect = (event) => {
        if (!this.contains(event.target)) return;
        const row = event.target.closest('details');
        if (row) row.open = true;
      };
      this.addEventListener('shopify:block:select', this.onSelect);
    }
    disconnectedCallback() { this.removeEventListener('shopify:block:select', this.onSelect); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talli-lunchbox-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('talli-lunchbox-quiz')) {
  class TalliLunchboxQuiz extends HTMLElement {
    static intent(answers) {
      const routes = new Set(answers.map((answer) => answer.route).filter((route) => ['bread', 'snacks', 'meal', 'mixed', 'wet'].includes(route)));
      const bread = routes.has('bread');
      const meal = routes.has('meal');
      const wet = routes.has('wet');
      const extra = routes.has('snacks') || wet;
      const route = routes.has('mixed') || ((bread || meal) && extra) || (bread && meal) ? 'mixed' : bread ? 'bread' : meal ? 'meal' : extra ? 'snacks' : undefined;
      return { route, bread, meal, wet, lunch: bread || meal || routes.has('mixed') };
    }

    static routeMatches(showFor, intent) {
      const state = typeof intent === 'string' ? {route:intent, bread:intent === 'bread', meal:intent === 'meal', lunch:['bread','meal','mixed'].includes(intent)} : intent || {};
      if (!showFor || showFor === 'always') return true;
      if (showFor === 'bread') return !!state.bread;
      if (showFor === 'meal') return !!state.meal && !state.bread;
      if (showFor === 'snacks') return state.route === 'snacks';
      if (showFor === 'lunch') return !!state.lunch;
      if (showFor === 'leakproof') return !!state.route && !state.wet;
      return showFor === state.route;
    }

    static recommendProfiles(products, answers) {
      const intent = TalliLunchboxQuiz.intent(answers);
      if (!intent.route) return [];
      const leakproof = intent.wet || answers.some((answer) => answer.rule === 'leakproof');
      const custom = answers.filter((answer) => answer.rule === 'custom');
      const candidates = products.filter((product) => product.profile).map((product) => {
        const profile = product.profile;
        const differences = [];
        const capacity = Number(profile.capacity_ml) || 0;
        if (!profile['use_' + intent.route]) differences.push('food');
        if (leakproof && !profile.leakproof) differences.push('leakproof');
        for (const answer of answers) {
          if (answer.rule === 'capacity') {
            if (capacity < answer.min) differences.push('smaller');
            else if (answer.max && capacity > answer.max) differences.push('larger');
          }
          if (answer.rule === 'separated' && !profile.separated) differences.push('separated');
          if (answer.rule?.startsWith('snack_') && !profile[answer.rule]) {
            const minimum = answer.rule === 'snack_small' ? 100 : answer.rule === 'snack_roomy' ? 400 : 0;
            if (minimum && capacity >= minimum && profile.use_snacks) differences.push('larger');
            else differences.push('snacks');
          }
          if (answer.rule === 'custom' && answer.required && !answer.products.includes(product.productId)) differences.push('custom');
        }
        const unique = [...new Set(differences)];
        const suitable = !unique.includes('food') && !unique.includes('leakproof');
        const kind = !unique.length ? 'exact' : unique.every((difference) => difference === 'larger') ? 'larger' : 'alternative';
        const group = suitable ? (product.available ? 0 : 1) : product.available ? 2 : 3;
        const tier = kind === 'exact' ? 0 : kind === 'larger' ? 1 : 2;
        const penalty = unique.reduce((sum, difference) => sum + ({food:1000, leakproof:10000, smaller:100, separated:20, snacks:30, custom:10, larger:1}[difference] || 0), 0);
        const score = custom.reduce((sum, answer) => sum + (answer.products.includes(product.productId) ? answer.weight : 0), 0);
        return {...product, differences:unique, kind, group, tier, penalty, score, capacity, intent};
      }).sort((a,b) => a.group - b.group || a.tier - b.tier || a.penalty - b.penalty ||
        (a.kind === 'larger' ? a.capacity - b.capacity : 0) || b.score - a.score || a.index - b.index);
      const hasSuitable = candidates.some((product) => product.group < 2);
      const seen = new Set();
      return candidates.filter((product) => {
        if (hasSuitable && product.group >= 2) return false;
        if (seen.has(product.productId)) return false;
        seen.add(product.productId);
        return true;
      });
    }

    static rankProfiles(products, answers, includeSoldOut = false) {
      return TalliLunchboxQuiz.recommendProfiles(products, answers).filter((product) => product.kind === 'exact' && (includeSoldOut || product.available));
    }

    static rank(products, answers, includeSoldOut = false) {
      const seen = new Set();
      return products.filter((product) => {
        if (seen.has(product.id)) return false;
        seen.add(product.id);
        return (includeSoldOut || product.available) &&
          answers.filter((answer) => answer.required).every((answer) => answer.products.includes(product.id));
      }).map((product) => ({
        ...product,
        score: answers.reduce((sum, answer) => sum + (answer.products.includes(product.id) ? answer.weight : 0), 0)
      })).filter((product) => product.score > 0)
        .sort((a, b) => b.score - a.score || a.index - b.index);
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.applyEditableCopy();
      this.questions = Array.from(this.querySelectorAll('[data-quiz-question]'));
      this.products = Array.from(this.querySelectorAll('[data-quiz-product]')).map((template, index) => ({
        id: template.dataset.id, productId: template.dataset.productId || template.dataset.id,
        available: template.dataset.available === 'true', template, index,
        profile: this.parseProfile(template.dataset.profile)
      }));
      this.labels = Object.fromEntries(Array.from(this.querySelectorAll('[data-label]')).map((label) => [label.dataset.label, label.textContent.trim()]));
      this.questions.forEach((question, index) => {
        question.querySelectorAll('[data-quiz-answer]').forEach((input) => {
          input.name = this.id + '-question-' + index;
          input.type = question.dataset.multiple === 'true' ? 'checkbox' : 'radio';
        });
      });
      this.valid = this.questions.length > 0 && this.products.length > 0 &&
        this.questions.every((question) => question.querySelector('[data-quiz-answer]'));
      this.querySelector('[data-quiz-start]').hidden = !this.valid;
      this.querySelector('[data-quiz-unavailable]').hidden = this.valid;
      if (this.valid) this.setAttribute('data-ready', '');
      else this.removeAttribute('data-ready');
      this.step = 0;
      this.setScreen('intro');
      this.browseTarget = document.querySelector('[data-quiz-browse-target]');
      if (this.browseTarget) this.querySelectorAll('.talli-quiz__browse').forEach((link) => { link.href = '#' + this.browseTarget.id; });
      this.onClick = (event) => {
        if (event.target.closest('.talli-quiz__browse') && this.browseTarget) {
          event.preventDefault();
          const header = document.querySelector('.section-header');
          const offset = (header?.getBoundingClientRect().height || 0) + 16;
          const top = Math.max(0, window.scrollY + this.browseTarget.getBoundingClientRect().top - offset);
          this.browseTarget.focus({preventScroll:true});
          window.scrollTo({top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          return;
        }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-quiz-start')) this.showStep(0);
        if (button.hasAttribute('data-quiz-collapse')) this.showIntro();
        if (button.hasAttribute('data-quiz-back')) this.step === 0 ? this.showIntro() : this.showStep(this.step - 1);
        if (button.hasAttribute('data-quiz-next')) {
          if (!this.questionAnswered(this.activeQuestions[this.step])) return;
          if (this.step < this.activeQuestions.length - 1) this.showStep(this.step + 1);
          else this.showResults();
        }
        if (button.hasAttribute('data-quiz-edit')) this.showStep(0);
        if (button.hasAttribute('data-quiz-reset')) {
          this.querySelectorAll('[data-quiz-answer]').forEach((input) => { input.checked = false; });
          this.showIntro();
        }
      };
      this.onChange = (event) => {
        if (event.target.matches('[data-quiz-answer]')) {
          this.updateRoute();
          this.updateProgress();
          this.updateNext();
        }
      };
      this.onBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const question = event.target.closest('[data-quiz-question]') || event.target.querySelector('[data-quiz-question]');
        const index = this.activeQuestions.indexOf(question);
        if (index >= 0) this.showStep(index);
        else this.showIntro(false);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.updateRoute();
      const settingsNotice = this.querySelector('[data-quiz-settings-notice]');
      if (settingsNotice) {
        settingsNotice.textContent = Array.from(this.querySelectorAll('[data-quiz-profile-error]'), (item) => item.textContent.trim()).join(' ');
        settingsNotice.hidden = !settingsNotice.textContent;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.initialized = false;
    }

    applyEditableCopy() {
      const blocks = Array.from(this.querySelectorAll('[data-quiz-copy-block]'));
      const block = blocks.find((item) => item.dataset.language === this.dataset.language) ||
        blocks.find((item) => item.dataset.language === 'en') || blocks.find((item) => item.dataset.language === 'nl');
      if (!block?.dataset.copy) return;
      let copy;
      try { copy = JSON.parse(block.dataset.copy); } catch { return; }
      const roots = [this, ...Array.from(this.querySelectorAll('[data-quiz-product]'), (item) => item.content)];
      roots.forEach((root) => root.querySelectorAll('[data-quiz-text]').forEach((node) => {
        const value = copy[node.dataset.quizText];
        if (typeof value === 'string' && value.trim()) node.textContent = value;
      }));
    }

    parseProfile(value) {
      try { return value ? JSON.parse(value) : null; } catch { return null; }
    }

    updateRoute() {
      const selected = this.questions.filter((question) => !question.dataset.showFor || question.dataset.showFor === 'always')
        .filter((question) => question.dataset.enabled !== 'false')
        .flatMap((question) => Array.from(question.querySelectorAll('input:checked')));
      this.intent = TalliLunchboxQuiz.intent(selected.map((input) => ({route:input.dataset.route})));
      this.route = this.intent.route;
      this.activeQuestions = this.questions.filter((question) => question.dataset.enabled !== 'false' && TalliLunchboxQuiz.routeMatches(question.dataset.showFor, this.intent));
      this.questions.filter((question) => !this.activeQuestions.includes(question)).forEach((question) => {
        question.querySelectorAll('input:checked').forEach((input) => { input.checked = false; });
      });
    }

    setScreen(screen) {
      this.dataset.screen = screen;
      this.querySelector('[data-quiz-start]')?.setAttribute('aria-expanded', String(screen !== 'intro'));
      ['intro', 'steps', 'results'].forEach((name) => {
        const panel = this.querySelector('[data-quiz-' + name + ']');
        const active = name === screen;
        panel.hidden = !active;
        panel.inert = !active;
      });
    }

    showIntro(focus = true) {
      this.updateRoute();
      this.setScreen('intro');
      if (focus) this.querySelector('[data-quiz-start]').focus({ preventScroll: true });
    }

    showStep(index) {
      this.updateRoute();
      if (!this.activeQuestions[index]) return;
      this.step = index;
      this.setScreen('steps');
      this.questions.forEach((question) => { question.hidden = question !== this.activeQuestions[index]; question.inert = question.hidden; });
      this.updateProgress();
      this.updateNext();
      this.activeQuestions[index].querySelector('legend').focus({ preventScroll: true });
    }

    updateProgress() {
      const progress = this.dataset.profiles === 'true' && !this.route ? this.labels.progress_pending : this.labels.progress;
      this.querySelector('[data-quiz-progress]').textContent = progress.replace('{current}', this.step + 1).replace('{total}', this.activeQuestions.length);
      const meter = this.querySelector('[data-quiz-meter]');
      meter.max = this.dataset.profiles === 'true' && !this.route ? this.questions.filter((question) => question.dataset.enabled !== 'false').length : this.activeQuestions.length;
      meter.value = this.step + 1;
    }

    updateNext() {
      const button = this.querySelector('[data-quiz-next]');
      const question = this.activeQuestions[this.step];
      button.disabled = !this.questionAnswered(question);
      button.textContent = this.dataset.profiles === 'true' && !this.route ? this.labels.next : this.step === this.activeQuestions.length - 1 ? this.labels.show_results :
        question?.dataset.optional === 'true' && !question.querySelector('input:checked') ? this.labels.skip : this.labels.next;
    }

    questionAnswered(question) {
      return !!question && (question.dataset.optional === 'true' || !!question.querySelector('input:checked'));
    }

    matchNote(item) {
      const differences = item.differences || [];
      const notes = differences.map((difference) => this.labels['match_' + difference]).filter(Boolean);
      if (item.available === false) notes.unshift(this.labels.match_sold_out);
      if (item.intent?.wet && item.intent.lunch) notes.push(this.labels.match_mixed_wet);
      return [...new Set(notes)].filter(Boolean).join(' ');
    }

    productFragment(item, best = false) {
      const fragment = item.template.content.cloneNode(true);
      if (best) {
        const extra = fragment.querySelector('[data-quiz-product-extra]');
        if (extra) this.querySelector('[data-quiz-best-details]').append(extra);
        const reason = fragment.querySelector('.talli-quiz__reason');
        if (reason) this.querySelector('[data-quiz-best-details]').prepend(reason);
      } else {
        const note = this.matchNote(item);
        if (note) {
          const paragraph = document.createElement('p');
          paragraph.className = 'talli-quiz__match-note';
          paragraph.textContent = note;
          fragment.querySelector('.talli-quiz__product').append(paragraph);
        }
      }
      return fragment;
    }

    showResults() {
      this.updateRoute();
      const missing = this.activeQuestions.findIndex((question) => !this.questionAnswered(question));
      if (missing >= 0) { this.showStep(missing); return; }
      const selected = this.activeQuestions.flatMap((question) => Array.from(question.querySelectorAll('input:checked')));
      const answers = selected.map((input) => ({
        products: input.dataset.products.split(',').filter(Boolean),
        required: input.dataset.required === 'true',
        weight: Math.max(0, Number(input.dataset.weight) || 0),
        route: input.dataset.route, rule: input.dataset.rule || 'custom',
        min: Math.max(0, Number(input.dataset.min) || 0), max: Math.max(0, Number(input.dataset.max) || 0)
      }));
      const ranked = this.dataset.profiles === 'true' ?
        TalliLunchboxQuiz.recommendProfiles(this.products, answers) :
        TalliLunchboxQuiz.rank(this.products, answers, this.dataset.includeSoldOut === 'true');
      const limit = Math.min(2, Math.max(0, Number(this.dataset.alternatives) || 0));
      const recommendations = ranked.slice(0, limit + 1);
      if (!recommendations.length) { this.showIntro(); return; }
      this.querySelector('[data-quiz-best-details]').replaceChildren();
      this.querySelector('[data-quiz-best]').replaceChildren(this.productFragment(recommendations[0], true));
      this.querySelector('[data-quiz-alternative-cards]').replaceChildren(...recommendations.slice(1).map((item) => this.productFragment(item)));
      this.querySelector('[data-quiz-alternatives]').hidden = recommendations.length < 2;
      this.querySelectorAll('[data-quiz-results] details').forEach((details) => { details.open = false; });
      this.querySelector('[data-quiz-alternative-count]').textContent = '(' + Math.max(0, recommendations.length - 1) + ')';
      const note = this.querySelector('[data-quiz-match-note]');
      note.textContent = this.matchNote(recommendations[0]);
      note.hidden = !note.textContent;
      if (note.textContent) {
        const reason = this.querySelector('[data-quiz-best] .talli-quiz__reason');
        if (reason) this.querySelector('[data-quiz-best-details]').prepend(reason);
      }
      const heading = this.querySelector('[data-quiz-result-title]');
      heading.textContent = recommendations[0].kind === 'alternative' || !recommendations[0].available ? this.labels.alternative_title : this.labels.result_title;
      this.querySelector('[data-quiz-summary]').replaceChildren(...selected.map((input) => {
        const item = document.createElement('li');
        item.textContent = input.closest('label').textContent.trim();
        return item;
      }));
      this.setScreen('results');
      this.focusResults();
    }

    focusResults() {
      const heading = this.querySelector('[data-quiz-result-title]');
      heading.focus({ preventScroll: true });
    }
  }
  customElements.define('talli-lunchbox-quiz', TalliLunchboxQuiz);
}

  } catch(e) { console.error(e); }
})();
})();
